export const RECURRING_FREQUENCIES = [
  'WEEKLY',
  'MONTHLY',
  'QUARTERLY',
  'ANNUALLY',
] as const;

export type RecurringFrequency = (typeof RECURRING_FREQUENCIES)[number];
